import { requireLoggedInUser } from '@/Router';
import { useAppStore } from '@/inertia/AppStore';
import { Skeleton } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

/**
 * All iframe-api routes are protected by authentication.
 */
export const Route = createFileRoute('/iframe-api')({
  pendingComponent: () => <Skeleton variant="rectangular" height={'100%'} width={'100%'} />,
  beforeLoad() {
    requireLoggedInUser({
      to: '/auth/login'
    });
  },
  onEnter() {
    useAppStore.setState({
      isDashboard: true
    });
  }
});